class OrderManagementSectionController {
    $onInit() {
        this.ariaLabel = `orderManagment-${this.orderType}-Header`;
    }
}

const orderManagementSectionComponentDefinition = {
    bindings: {
        orders: '<',
        orderType: '@',
        showTimer: '=',
    },
    transclude: true,
    controller: [OrderManagementSectionController],
    template: require('./order-management-section.component.html').trim(),
};

module.exports = {
    OrderManagementSectionController,
    orderManagementSectionComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management-section.component.js